<template>
  <div class="parent-box">
    <!-- 列表数据 -->
    <div class="content">
      <van-list
        v-model:loading="state.loading"
        :finished="state.finished"
        finished-text="没有更多了"
        @load="onLoad"
      >
        <van-cell
          v-for="(item, i) in state.ktLists"
          :key="i + '-list'"
          :border="false"
        >
          <template #value>
            <p>
              <span>省钱月卡</span><span>{{ item.days }}天</span>
            </p>
            <p>会员开通时间：{{ item.success_time }}</p>
            <p>
              开通方式：
              <span v-if="item.pay_bank == 'wx'">
                <img src="../../../assets/personal/ico_wxzf.png" alt="" />
                微信支付
              </span>
              <span v-else="item.pay_bank == 'zfb'">
                <img src="../../../assets/personal/ico_zfbzf.png" alt="" />
                支付宝支付
              </span>
            </p>
            <p>付款金额：{{ item.pay_money }}</p>
          </template>
        </van-cell>
      </van-list>
    </div>
  </div>
</template>
<script>
import { useRouter } from "vue-router";
import { reactive, onMounted, onUnmounted } from "vue";
import { useStore } from "vuex";
import { monthCardRecord } from "@/api/yzuser.js";
import { setToken, getToken, getUid } from "@/utils/auth";
import { getQueryString } from "@/utils/location";
import { Skeleton, Toast } from "vant";
export default {
  name: "open_record",
  setup() {
    const router = useRouter();
    const store = useStore();
    const state = reactive({
      ktLists: [],
      loading: false,
      finished: false,
      SkeletonLoading: true,
    });
    onMounted(() => {
      // onLoad()
    });

    var pagecode = 1;
    var totalpage = 1;
    const onLoad = () => {
      monthCardRecord({
        // uid: 7888,
        uid: getQueryString("uid"),
        // uid: localStorage.getItem('uid'),
        pagecode: pagecode,
      }).then((res) => {
        console.log(res);
        if (res.data.code == 1) {
          state.SkeletonLoading = false;
          totalpage = res.data.data.total_page;
          state.ktLists = state.ktLists.concat(res.data.data.lists);
          console.log(state.ktLists);
        } else {
          Toast(res.data.msg);
          state.finished = true;
        }
        // console.log(pagecode)
        pagecode++;
        if (pagecode > res.data.data.total_page) {
          state.finished = true;
          return;
        }
        state.loading = false;
      });
    };

    onUnmounted(() => {
      state.ktLists = [];
    });
    return {
      state,
      onLoad,
    };
  },
};
</script>
<style scoped="scoped">
.parent-box {
  padding-top: 30px;
  height: 100vh;
  background-color: #f7f8fa;
}

.content {
  padding: 0 32px;
}

.van-cell__value--alone p:nth-of-type(1) {
  display: flex;
  justify-content: space-between;
}

.van-cell {
  width: 686px;
  height: 238px;
  background-color: #fff;
  border-radius: 16px;
  padding: 24px 32px 0 24px;
  font-size: 24px;
  margin-bottom: 20px;
}
.van-cell p {
  color: #333;
}

.van-cell p:nth-of-type(1) {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 32px;
  color: #333;
  font-weight: 500;
}

.content ul li p:nth-of-type(2) {
  margin: 12px 0;
  color: #333;
}

.content img {
  width: 35px;
  height: 35px;
  vertical-align: middle;
}
</style>
